// eslint-disable-next-line import/prefer-default-export
export const selectTeamByIdSelector = (teams, teamId) => {
    const selectedTeam = teams.find(
        (team) => String(team.id) === String(teamId),
    );

    return selectedTeam;
};
